/**************************************************
 * Nombre:       Tarjetas_Producto_Tab
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjetas_Producto_Tab = ({item, click, index}) => {


    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, mt: 2, cursor: 'pointer'}}
            spacing={2}
        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={0}
                sx={{py: 1}}
            >


                <Grid container size={12}>
                    <Typography
                        sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.nombre}`}</Typography>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjetas_Producto_Tab